export default {"src":"/_next/static/media/threelinesgear.8a6028bc.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};